import React from 'react';
import { useLocation } from 'react-router-dom';
import { useHealthMode } from '../context/HealthModeContext';
import { useDashboard } from '../context/DashboardContext';
import Header from './Layout/Header';

const DashboardAwareHeader: React.FC = () => {
  const location = useLocation();
  const isDashboard = location.pathname === '/dashboard';
  const { healthMode, setHealthMode } = useHealthMode();
  
  // Always call the dashboard hook since we're always inside DashboardProvider now
  const dashboardContext = useDashboard();
  
  const currentView = isDashboard ? dashboardContext.currentView : 'dashboard';
  const onViewChange = isDashboard ? dashboardContext.setCurrentView : undefined;

  return (
    <Header
      healthMode={healthMode}
      onHealthModeChange={setHealthMode}
      showHealthToggle={isDashboard}
      showDashboardNav={isDashboard}
      currentView={currentView}
      onViewChange={onViewChange}
    />
  );
};

export default DashboardAwareHeader;